import React from 'react';
import { Card, Button } from 'antd';
import {
  WindowsOutlined,
  AndroidOutlined,
  QqOutlined,
} from '@ant-design/icons';

function DocsDownloadCard({ t }) {
  return (
    <Card className="docs__item docs-item">
      <div className="docs-item__title">{t('distr-title')}</div>
      <div className="docs-item__content">
        <div className="docs-item__download-item docs-download-item">
          <Button
            className="docs-download-item__info"
            size="large"
            icon={<WindowsOutlined className="docs-download-item__icon" />}
            href="https://visiobox.cloud/dist/win-x86/visiobox.msi"
            target="_blank"
          >
            <span className="docs-download-item__text">
              {t('download-for')} Windows
            </span>
            <span className="docs-download-item__size">92 {t('MB')}.</span>
          </Button>
          <Button type="link" href="https://bit.ly/2FmPCkb" target="_blank">
            {t('instruction')}
          </Button>
        </div>

        <div className="docs-item__download-item docs-download-item">
          <Button
            className="docs-download-item__info"
            size="large"
            icon={<AndroidOutlined className="docs-download-item__icon" />}
            href="http://android.visiobox.ru/update/visiobox.cloud/release-2.1.7.apk"
            target="_blank"
          >
            <span className="docs-download-item__text">
              {t('download-for')} Android
            </span>
            <span className="docs-download-item__size">7 {t('MB')}.</span>
          </Button>
          <Button type="link" href="http://bit.ly/2oQhzbS" target="_blank">
            {t('instruction')}
          </Button>
        </div>

        <div className="docs-item__download-item docs-download-item">
          <Button
            className="docs-download-item__info"
            size="large"
            icon={<AndroidOutlined className="docs-download-item__icon" />}
            href="http://android.visiobox.ru/update/visiobox.cloud/release-2.1.7.apk"
            target="_blank"
          >
            <span className="docs-download-item__text">
              {t('download-for')} Android
            </span>
            <span className="docs-download-item__size">7 {t('MB')}.</span>
          </Button>
          <Button type="link" href="http://bit.ly/2oQhzbS" target="_blank">
            {t('instruction')}
          </Button>
        </div>

        <div className="docs-item__download-item docs-download-item">
          <Button
            className="docs-download-item__info"
            size="large"
            icon={<QqOutlined className="docs-download-item__icon" />}
          >
            <span className="docs-download-item__text">
              {t('download-for')} Linux
            </span>
            <span className="docs-download-item__size">12 {t('MB')}.</span>
          </Button>
          <Button type="link">{t('instruction')}</Button>
        </div>
      </div>
    </Card>
  );
}

export default DocsDownloadCard;
